import React from "react";

const SurveyIntro = () => {
  return (
    <div className="surevy_content text-center  mb-2">
      <p
        className="text-[16px] font-[500] my-[10px] text-black text-justify"
        style={{
          lineHeight: "1.5",
        }}
      >
        A-Tool&copy; is a survey questionnaire that helps to identify
        undiagnosed axial spondyloarthritis (axSpA) among people with chronic
        back/hip/buttock pain. axSpA is an inflammatory disease that causes pain
        and inflammation in the spine, joints, tendons and may involve eyes,
        skin and intestines. Diagnosis is often delayed or missed; however,
        effective medications are available.
      </p>

      <p
        className="font-bold text-[22px] text-blue-700"
        style={{ color: "#000D44" }}
      >
        Answer the following questions if you have chronic back/hip/buttock pain
        for more than 3 months
        <span className="text-red-600 font-bold"> AND </span>
        you started experiencing these symptoms before the age of 45 years.
      </p>
    </div>
  );
};

export default SurveyIntro;
